import Api from "../../../api";

import { Duty } from "./models";
import { PlaceCategories } from "../models";

import placesService from "../service";

const dutiesUrl = "/pharmacies/duties";


class DutyApi extends Api {
	
	constructor(baseUrl) {
		super(baseUrl + dutiesUrl);
	}
	
	search(startTime, endTime, callback) {
		var url = this.baseUrl;

		this.client.get(url, { params: { startTime: startTime, endTime: endTime } })
			.then((response) => {

				var data = [];
				for (var index = 0; index < response.data.length; index++) {
					data.push(new Duty(response.data[index]));
				}

				callback({
					result: data,
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	get(callback) {
		var url = this.baseUrl;

		this.client.get(url)
			.then((response) => {

				var data = [];
				for (var index = 0; index < response.data.length; index++) {
					data.push(new Duty(response.data[index]));
				}

				callback({
					result: data,
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	create(duty, callback) {
		var url = this.baseUrl;

 		this.client.post(url, duty)
			.then((response) => {
				callback({
					result: new Duty(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	delete(dutyId, callback) {
		var url = this.baseUrl + "/" + dutyId;

 		this.client.delete(url)
			.then((response) => {
				callback({
					result: response.data,
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	update(duty, callback) {
		var url = this.baseUrl + "/" + duty.id;

 		this.client.put(url,duty)
			.then((response) => {
				callback({
					result: response.data,
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}
	
}

class PharmacyApi extends Api {
	
	get(callback) {
		placesService.api.places.search(PlaceCategories.PHARMACY, false, null, callback);
	}

}

class PharmaciesApi {

	constructor(baseUrl) {
		this.pharmacies = new PharmacyApi();
		this.duties = new DutyApi(baseUrl);
	}

}


export default PharmaciesApi;